import React, { Component } from 'react';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import { changeUnauthlang,getDeviceAndWidth } from 'src/Utils';
import { cardList, expiredConstants } from './expiredConstants';
import './styles.scss';
import { connect } from 'react-redux';
import { signOut } from 'src/authConfig';
import { withTranslation } from 'react-i18next';

class Expired extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let activeLanguage =  localStorage.getItem('activeLanguage');
    this.updateLanguageTranslation(activeLanguage);
  }

  renderCardList = () => {
    return (
      <section className="cards-list-wrapper__lower-half">
        {React.Children.toArray(
          cardList.map((card) => (
            <div key={i} className="card-container">
              <img src={card.img} className="card-image" />
              <h6 className="card-heading">{card.heading}</h6>
              <p className="card-info-text">{card.infoText}</p>
            </div>
          ))
        )}
      </section>
    );
  };

  updateLanguageTranslation = (languageName) => {
    const { i18n ,unAuth = false} = this.props;
    if(unAuth){
      changeUnauthlang(i18n,languageName)
    }
  };

  getActiveKey = () => {
    const { GE2CExpired, C2CExpired, isForbidden } = this.props.subscription;
    if (isForbidden) {
      return 'unauthConstants';
    } else if (GE2CExpired && !C2CExpired) {
      return 'GE2CConstants';
    } else if (!GE2CExpired && C2CExpired) {
      return 'C2CConstants';
    } else {
      return 'mixedConstants';
    }
  };

  logoutSession = () => {
    localStorage.setItem('isAutomaticLogout', false);
    signOut();
  };

  renewSubscription = () => {
    window.open(
      'https://www.gehealthcare.com/products/ultrasound/ultrasound-digital-solutions/digital-expert',
      '_blank'
    );
  };

  render() {
    const activeKey = this.getActiveKey();
    const { bothExpired } = this.props.subscription;
    return ( 
      <div
        className="expired-screen-wrapper"
        style={{ padding: bothExpired ? '0 24px' : '0' }}
      >
       {<div className="expired-container">
          <h3 className="heading__expired">
            {expiredConstants[activeKey].pageHeading}
          </h3>
          <p className="heading-helper-text__expired">
            {expiredConstants[activeKey].headingHelperText}
          </p>
          <PrimaryButtonGE
            text={
              getDeviceAndWidth().device === 'desktop'
                ? expiredConstants[activeKey].renewBtn.desktop.text
                : expiredConstants[activeKey].renewBtn.tablet.text
            }
            className="cta-button__expired"
            onClick={this.renewSubscription}
          />
          <section className="lower-half-data__expired">
            <p className="tagline-text__lower-half">
              <span className="tagline-part1-text">
                {expiredConstants[activeKey].tagline.taglinePart1}
              </span>
            </p>
            {this.renderCardList()}
          </section>
          {bothExpired && (
            <p className="logout-btn" onClick={this.logoutSession}>
              {expiredConstants.mixedConstants.logout.text}
            </p>
          )}
        </div>}
      </div>
    );
  }
}

const mapStateToProps = ({ subscription }) => ({
  subscription,
});

const mapDispatchToProps = (dispatch) => ({});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Expired));
